module.exports = __webpack_public_path__ + "61527fd361709c62bcc6a5dca3fbba2a.fbx";